<script>
    export let product = {};
    
    let attributes = [ product.attributes ];

    let subtotal = product.quantity * product.offeredPrice;
</script>

<style>
    .bag__product{
        padding: 1rem 0;
        border-bottom: 1px solid #EEEEEE;
    }
    .bag__product img{
        width: 5rem;
    }
    .bag__product-image, .bag__product-details, .bag__product-price{
        display: inline-block;
        vertical-align: top;
    }
    .bag__product-details{
        margin-left: 0.5rem;
    }
    .bag__product-name{
        margin-bottom: 0.5rem;
        font-size: 1.1rem;
        font-weight: 500;
    }
    .bag__product-regional-name{
        margin-bottom: 0.3rem;
    }
    .bag__product-price{
        float: right;
        /* margin-top: 1.5rem; */
        font-size: 1.5rem;
    }
    .bag__product-options{
        margin: 0.5rem 0 0 0;
    }
    .bag__product-options>*{
        color: #999999;
    }
</style>

<div class="bag__product">
    <div class="bag__product-image">
        <img src="{product.image}" alt="{product.imageAlt}"/>
    </div>

    <div class="bag__product-details">
        <div class="bag__product-name">{product.name}</div>
        <div class='bag__product-regional-name'>{product.regionalName}</div>
        <div>
            {#each attributes as attribute}
                {#each Object.keys(attribute) as key}
                    <span>{ attribute[key] }</span>
                    <span> • </span>
                {/each}
            {/each}

            <span>Qty.</span>
            <span>{product.quantity}</span>
        </div>
        <div class="bag__product-options">
            <a href="#product-page">Change</a>
            <span> • </span>
            <a href="#delete">Delete</a>
        </div>
    </div>
    <div class="bag__product-price">₹{subtotal}</div>
</div>
